import { Event } from "@/common/types"
import { Grid, IconButton, Paper, Typography } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import dayjs from "dayjs"
import useDialogState from "@/hooks/useDialogState"
import ConfirmDeleteEventDialog from "@/dialogs/events/ConfirmDeleteEventDialog"
import ConfirmEditEventDialog from "@/dialogs/events/EditEventDialog"

export default function EventCard({ event }: { event: Event }) {
  const { openDialog, ...dialogState } = useDialogState({})
  const { openDialog: openEdit, ...editDialogState } = useDialogState({})
  return (
    <>
      <Paper
        sx={{
          padding: 2,
          borderRadius: "12px",
          borderColor: "stroke",
          borderStyle: "solid",
          borderWidth: "1px",
          margin: 2,
        }}
      >
        <Grid container>
          <Grid item xs={3}>
            <Typography>{event.title}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>
              {dayjs(event.event_start_timestamp).format("MMMM DD, YYYY HH:mm")}
            </Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={1}>
            <IconButton sx={{ padding: 0 }} onClick={openEdit}>
              <EditIcon color="primary" />
            </IconButton>
          </Grid>
          <Grid item xs={1}>
            <IconButton sx={{ padding: 0 }} onClick={openDialog}>
              <DeleteIcon color="error" />
            </IconButton>
          </Grid>
        </Grid>
      </Paper>
      <ConfirmDeleteEventDialog {...dialogState} eventId={event.event_id} />
      <ConfirmEditEventDialog {...editDialogState} event={event} />
    </>
  )
}
